import React, { useEffect } from 'react';
import {
  useParams,
} from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { env } from '../../../config';
import useHttpStatus from '~/commons/hooks/useHttpStatus';
import Header from '../../layout/Header.jsx';
import PageHttp from '~/commons/components/PageHttp.jsx';
import FormStudent from '../../forms/FormStudent.jsx';
import { getLang } from '~/commons/helpers';

const PageSchoolStudent = () => {
  const { _id, studentId } = useParams();
  const [schoolRes, schoolReq] = useHttpStatus();
  const [studentRes, studentReq] = useHttpStatus();
  const { t, i18n: { language } } = useTranslation();

  useEffect(() => {
    schoolReq({ url: `/api/core/schools/${_id}` });

    if (studentId !== 'new') {
      studentReq({ url: `/api/core/users/students/${studentId}` });
    }
  }, [_id, studentId]);

  const res = [schoolRes];

  if (studentId !== 'new') {
    res.push(studentRes);
  }

  return (
    <PageHttp res={res}>
      {([school, student]) => {
        const breadcrumb = [
          { to: '../../', children: getLang(school.title, language) },
        ];
        if (env.user.roles.includes('admin')) {
          breadcrumb.unshift(
            { to: '../../../', children: 'Schools' },
          );
        }

        return studentId === 'new' ? (
          <>
            <Header breadcrumb={breadcrumb}>{t('New ') + t('Student')}</Header>
            <FormStudent school={school} />
          </>
        ) : (
          <>
            <Header breadcrumb={breadcrumb}>{t('Edit ') + t('Student')}</Header>
            <FormStudent
              school={school}
              student={student}
            />
          </>
        );
      }}
    </PageHttp>
  );
};

export default PageSchoolStudent;
